// auto-generated by Typewriter template _enums.tst from PortCall.Models\Users\PhoneNumber.cs
export enum PhoneNumberKind { 
    Office = 0,
    Mobile = 10,
    Fax = 20,
    Home = 30,
    TwentyFourSeven = 31,
    Other = 40
}

export const PhoneNumberKindDisplayName : { [val : number] : string } = { 
    0: 'Office',
    10: 'Mobile',
    20: 'Fax',
    30: 'Home',
    31: '24/7',
    40: 'Other'
}

export const PhoneNumberKinds : { Id : PhoneNumberKind, Name : string }[] = [ 
    { Id: PhoneNumberKind.Office, Name: 'Office' },
    { Id: PhoneNumberKind.Mobile, Name: 'Mobile' },
    { Id: PhoneNumberKind.Fax, Name: 'Fax' },
    { Id: PhoneNumberKind.Home, Name: 'Home' },
    { Id: PhoneNumberKind.TwentyFourSeven, Name: '24/7' },
    { Id: PhoneNumberKind.Other, Name: 'Other' }
]



// WEBPACK FOOTER //
// ./server/enums/PhoneNumberKind.ts